export function getUserRank(points: number) {
  if (points >= 1000) return { title: 'Legend', classes: 'text-fuchsia-400 bg-fuchsia-400/10 border border-fuchsia-400/20' }
  if (points >= 500) return { title: 'Server Guru', classes: 'text-amber-400 bg-amber-400/10 border border-amber-400/20' }
  if (points >= 100) return { title: 'Veteran', classes: 'text-emerald-400 bg-emerald-400/10 border border-emerald-400/20' }
  if (points >= 25) return { title: 'Member', classes: 'text-blue-400 bg-blue-400/10 border border-blue-400/20' }
  return { title: 'Initiate', classes: 'text-slate-400 bg-slate-400/10 border border-slate-400/20' }
}
